<template>
  <div class="container">
    <div class="topBox">
      <van-tabs
        v-model="tabActive"
        background="#fff"
        color="#2D90EF"
        title-inactive-color="#666666"
        title-active-color="#2D90EF"
        @change="onChangeTab"
      >
        <van-tab
          v-for="item in tabArr"
          :key="item.name"
          :name="item.value"
          :title="item.name"
        />
      </van-tabs>
    </div>

    <van-list
      class="listBox"
      :loading.sync="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <ul class="list">
        <li v-for="(item, index) in list" :key="item.subOrderNo + index">
          <div
            class="goods"
            @click="
              $router.push({
                name: 'liaoningHighwayDetail',
                query: { subOrderNo: item.subOrderNo }
              })
            "
          >
            <img :src="item.gcCoverUrl" />
            <div class="goodsInfo">
              <h4>{{ item.goodsName }}</h4>
              <div>有效期至: {{ item.expireTime }}</div>
              <div>券ID: {{ item.codeId || item.subOrderNo }}</div>
            </div>
          </div>
          <div class="expired" v-show="isExpired(item.expireTime)">已失效</div>
        </li>
      </ul>
    </van-list>
  </div>
</template>

<script>
import moment from 'moment'
import { liaoNingList } from '@/api/liaoningHighway'
export default {
  data() {
    return {
      tabActive: 2,
      tabArr: [
        {
          name: '全部',
          value: 2
        },
        {
          name: '失效',
          value: 1
        }
      ],
      loading: false,
      finished: false,
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 30
    }
  },
  methods: {
    onChangeTab() {
      this.pageNum = 1
      this.list = []
      this.finished = false
      this.onLoad()
    },
    isExpired(time) {
      // 如果没有过期时间，则认为未过期
      if (!time) return false
      return moment(time).isBefore(moment())
    },
    onLoad() {
      this.loading = true
      liaoNingList({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        param: this.tabActive === 2 ? undefined : this.tabActive
      })
        .then(res => {
          const { records, total } = res.data
          this.total = total
          if (this.pageNum === 1) {
            this.list = records
          } else {
            this.list.push(...records)
          }
          this.loading = false
          if (this.pageNum * this.pageSize >= this.total) {
            this.finished = true
          }
          this.pageNum++
        })
        .catch(() => {
          this.loading = false
          this.finished = true
        })
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  background: #f0f0f0;
  min-height: 100%;
  .topBox {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    width: 100%;
    height: 50px;
    z-index: 999;
  }
  .listBox {
    margin-top: 50px;
    .list {
      padding-top: 20px;
      li {
        position: relative;
        .expired {
          position: absolute;
          top: 0;
          right: 12px;
          background: #e5e5e5;
          border-radius: 0px 5px 0px 5px;
          font-size: 10px;
          color: #999999;
          width: 50px;
          height: 16px;
          text-align: center;
        }
        .goods {
          display: flex;
          align-items: center;
          padding: 15px;
          background: #ffffff;
          border-radius: 5px;
          margin: 0 12px 12px 12px;
          img {
            width: 71px;
            height: 71px;
            margin-right: 14px;
          }
          .goodsInfo {
            width: 0;
            flex: 1;
            font-size: 12px;
            color: #999999;
            line-height: 20px;
            h4 {
              font-size: 16px;
              color: #000000;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              padding-bottom: 4px;
            }
          }
        }
      }
    }
  }
}
</style>
